import axios from 'axios';
import isProd from './getEnv';
import store from './store';
import { API_CLOUD_WATCH, FRONTEND_DASHBOARD_ALERT } from '../constants';
import { version } from '../../package.json';


import { DescriptiveError } from 'topkat-utils'

export function applicationError(
  msg,
  extraInfos = {},
  options = {} // TODO when passing to typescript replace doNotThrow by doThrow in type
) {
  const { doThrow = true, doLog = true } = options
  const { shopId } = store.getState().user;
  // TODO put additional contextual information about user for example

  const error = new DescriptiveError(msg, {
    // stack traces are by default in the browser console
    // and this one is not relevant as it does not take in
    // account source map files
    noStackTrace: true,
    shopId,
    ...extraInfos,
    doNotThrow: true,
  })

  if (doLog) error.log()
  else error.hasBeenLogged = true

  const cloudWatchParsedLogs = error.logs.join('\n') + '\n'
  sendCloudWatchAlert(cloudWatchParsedLogs, false)
  if (doThrow) throw error
}

export const sendCloudWatchLogs = async (message, enableLogging = true) => logErr(message, 'info', enableLogging)

export const sendCloudWatchAlert = async (message, enableLogging = true) => logErr(message, 'error', enableLogging)

async function logErr(message, level, enableLogging = true) {
  let customMessage = message
  try {
    const stackTrace = (new Error()).stack
    const { shopId } = store.getState().user;
    customMessage = `${level === 'error' ? `${FRONTEND_DASHBOARD_ALERT} ` : ''}DISHOP DASHBOARD ${version} | SHOP ID: ${shopId} | ${message}`

    if (isProd()) {
      // stack trace is necessary
      await axios.post(API_CLOUD_WATCH, { message: customMessage + '\n' + stackTrace })
    }

  } catch (error) {
    console.error('Error streaming logs to cloudwatch', error);
  }
  if (enableLogging) {
    // log the message whatever happens
    if (level === 'error') console.error(customMessage);
    else console.log(customMessage)
  }
}
